export function getSliderDescriptionSlides(t) {
  return [
    {
      value: '35',
      subtitle: t('basicTrainingZone.slider[0].subtext'),
      description: t('basicTrainingZone.slider[0].description'),
    },
    {
      value: '3',
      subtitle: t('basicTrainingZone.slider[1].subtext'),
      description: t('basicTrainingZone.slider[1].description'),
    },
    {
      value: '4',
      subtitle: t('basicTrainingZone.slider[2].subtext'),
      description: t('basicTrainingZone.slider[2].description'),
    },
    {
      value: `${t('basicTrainingZone.slider[3].subtext')} 65+`.trim(),
      description: t('basicTrainingZone.slider[3].description'),
    },
  ];
}
